// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.angebot-select select {
  background-color: var(--mittelgruen);
  border: none;
  padding: 10px 40px 10px 10px;
  border-radius: 10px;
  width: 100%;
  color: #9fb05f;
  margin-bottom: 15px;
  font-family: 'Circular', sans-serif;
  text-transform: none;
}

.angebot-form input[type="text"],
.angebot-form input[type="number"],
.angebot-form textarea {
  background-color: var(--mittelgruen);
  border: none;
  padding: 10px;
  border-radius: 5px;
  width: 100%;
  color: var(--dunkelgruen);
  margin-bottom: 15px;
  font-size: 1em;
}

/* selected option style */

.dropdown-wrapper.filled select {
  color: var(--dunkelgruen);
  font-weight: normal;
}

.angebot-select h3 {
  color: var(--dunkelgruen);
}

.angebot-select select option[disabled] {
  color: #9fb05f;
}


.angebot-form {
  text-align: left;
}

.angebot-select {
  margin-bottom: 1rem;
  text-align: left;
}

.fv-map-container {
  margin-bottom: 1rem;
}

.fv-map-link {
  display: flex;
  align-items: center;
  gap: 0.3rem;
}

.fv-map-label {
  color: var(--dunkelgruen);
  font-size: 1em;
  text-decoration: underline;
  text-underline-offset: 4px;
}

.fv-map-icon {
  font-size: 1.2rem;
  color: var(--dunkelgruen);
}

.actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.delete-link {
  display: flex;
  align-items: center;
  gap: 0.2rem;
  cursor: pointer;
  margin-left: 0.5rem;
}

.delete-label {
  color: var(--blutorange);
  font-size: 1.2rem;
  text-decoration: underline;
  text-underline-offset: 4px;
}

.delete-icon {
  font-size: 1.2rem;
  color: var(--blutorange);
  margin-left: 0.2rem;
}
`, "",{"version":3,"sources":["webpack://./src/freizeit/freizeitverwaltung/FreizeitVerwaltung.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,YAAY;EACZ,4BAA4B;EAC5B,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,mCAAmC;EACnC,oBAAoB;AACtB;;AAEA;;;EAGE,oCAAoC;EACpC,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,0BAA0B;;AAE1B;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;AACrB","sourcesContent":[".angebot-select select {\n  background-color: var(--mittelgruen);\n  border: none;\n  padding: 10px 40px 10px 10px;\n  border-radius: 10px;\n  width: 100%;\n  color: #9fb05f;\n  margin-bottom: 15px;\n  font-family: 'Circular', sans-serif;\n  text-transform: none;\n}\n\n.angebot-form input[type=\"text\"],\n.angebot-form input[type=\"number\"],\n.angebot-form textarea {\n  background-color: var(--mittelgruen);\n  border: none;\n  padding: 10px;\n  border-radius: 5px;\n  width: 100%;\n  color: var(--dunkelgruen);\n  margin-bottom: 15px;\n  font-size: 1em;\n}\n\n/* selected option style */\n\n.dropdown-wrapper.filled select {\n  color: var(--dunkelgruen);\n  font-weight: normal;\n}\n\n.angebot-select h3 {\n  color: var(--dunkelgruen);\n}\n\n.angebot-select select option[disabled] {\n  color: #9fb05f;\n}\n\n\n.angebot-form {\n  text-align: left;\n}\n\n.angebot-select {\n  margin-bottom: 1rem;\n  text-align: left;\n}\n\n.fv-map-container {\n  margin-bottom: 1rem;\n}\n\n.fv-map-link {\n  display: flex;\n  align-items: center;\n  gap: 0.3rem;\n}\n\n.fv-map-label {\n  color: var(--dunkelgruen);\n  font-size: 1em;\n  text-decoration: underline;\n  text-underline-offset: 4px;\n}\n\n.fv-map-icon {\n  font-size: 1.2rem;\n  color: var(--dunkelgruen);\n}\n\n.actions {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.delete-link {\n  display: flex;\n  align-items: center;\n  gap: 0.2rem;\n  cursor: pointer;\n  margin-left: 0.5rem;\n}\n\n.delete-label {\n  color: var(--blutorange);\n  font-size: 1.2rem;\n  text-decoration: underline;\n  text-underline-offset: 4px;\n}\n\n.delete-icon {\n  font-size: 1.2rem;\n  color: var(--blutorange);\n  margin-left: 0.2rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
